module.exports = __webpack_public_path__ + "img/rakugaki.da987cdf.png";